import { invoiceFlowSchema } from "@station/contracts";
import { toIstanbulDate } from "@station/core";
import { EmptyState } from "@station/ui";
import { createFileRoute } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { companySearchShape } from "../../../../features/accounting/company.js";
import { DespatchForm } from "../../../../features/invoicing/despatch-form.js";
import { blankDespatchHeader, blankDespatchLine } from "../../../../features/invoicing/invoice-values.js";
import {
  InvoicingPage,
  useInvoicingCrumb,
  useInvoicingPermissions,
} from "../../../../features/invoicing/shared.js";

const searchSchema = z.object({
  ...companySearchShape,
  flow: invoiceFlowSchema.optional().catch(undefined),
});

export const Route = createFileRoute("/_app/faturalar/irsaliyeler/yeni")({
  validateSearch: (search) => searchSchema.parse(search),
  component: NewDespatchPage,
});

function NewDespatchPage() {
  const { t } = useTranslation();
  const search = Route.useSearch();
  const crumb = useInvoicingCrumb("/faturalar/irsaliyeler");
  const permissions = useInvoicingPermissions();
  const flow = search.flow ?? "OUTGOING";

  return (
    <InvoicingPage
      title={t("invoicing.despatch.new")}
      description={t("invoicing.despatch.newDescription")}
      breadcrumb={[crumb, { label: t("invoicing.despatch.new") }]}
    >
      {({ companyId }) =>
        permissions.canManageDespatch ? (
          <DespatchForm
            key={flow}
            companyId={companyId}
            initialHeader={blankDespatchHeader(flow, toIstanbulDate(new Date()))}
            initialLines={[blankDespatchLine()]}
            saved={null}
          />
        ) : (
          <EmptyState
            headingLevel={2}
            icon={<ShieldAlert />}
            title={t("invoicing.form.noPermission")}
            description={t("invoicing.form.noPermissionBody")}
          />
        )
      }
    </InvoicingPage>
  );
}
